"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL_STORAGE_AWS = exports.TYPE_DRAW_MAP = exports.TYPES_PAYMENTS = exports.SUBPLOT = exports.SCHOOLINGS = exports.SCHEDULING_STATUS = exports.ROW = exports.ROLES_USERS_FUNCTIONS_COMPLETE = exports.ROLES_USERS_FUNCTIONS = exports.QUANTITY_MEASURE = exports.POSITION_DROPDOWN = exports.OPTIONS_TABLE = exports.NUMBER_SUB_PLOTS = exports.MONEY_INTEGER = exports.MONEY = exports.MODELS_TAGS_RASTREIO = exports.LIST_TYPES_PROVIDERS = exports.LIST_STATES = exports.LIST_MONTHS_MINUS = exports.LIST_EMBALAGENS = exports.LIST_CUSTOM_FIELDS_OPTIONS = exports.LIST_CUSTOM_FIELDS = exports.LIST_ADMINS = exports.KEY_USER_LOCAL_STORAGE_FARM = exports.KEY_USER_LOCAL_STORAGE = exports.FAMILIE = exports.BUNCH = exports.BASE_DRAW_MAP = void 0;
/**
 * URL S3 AWS
 */
var URL_STORAGE_AWS = exports.URL_STORAGE_AWS = 'https://fiboo-documents.s3.us-east-2.amazonaws.com';
/**
 * KEY LocalStorageUser
 */
var KEY_USER_LOCAL_STORAGE = exports.KEY_USER_LOCAL_STORAGE = 'current_user';
/**
 * KEY LocalStorageUser
 */
var KEY_USER_LOCAL_STORAGE_FARM = exports.KEY_USER_LOCAL_STORAGE_FARM = 'farm_selected';
/**
 * STATUS ACCEPTED IN THE SERVICES
 */
var SCHEDULING_STATUS = exports.SCHEDULING_STATUS = [{
  name: 'Agendado',
  value: 'SCHEDULED'
}, {
  name: 'Em andamento',
  value: 'IN_PROGRESS'
}, {
  name: 'Concluído',
  value: 'FINISHED'
}];
/**
 * NUMBER OF SUBPLOTS THAT ARE CREATED BY DRAWING UP
 */
var NUMBER_SUB_PLOTS = exports.NUMBER_SUB_PLOTS = 4;
/**
 * LIST USERS MASTERS
 */
var LIST_ADMINS = exports.LIST_ADMINS = ['Owner', 'Admin'];
/**
 * LIST USERS MASTERS
 */
var LIST_STATES = exports.LIST_STATES = [{
  uf: 'AC',
  description: 'Acre'
}, {
  uf: 'AL',
  description: 'Alagoas'
}, {
  uf: 'AP',
  description: 'Amapá'
}, {
  uf: 'AM',
  description: 'Amazonas'
}, {
  uf: 'BA',
  description: 'Bahia'
}, {
  uf: 'CE',
  description: 'Ceará'
}, {
  uf: 'DF',
  description: 'Distrito Federal'
}, {
  uf: 'ES',
  description: 'Espírito Santo'
}, {
  uf: 'GO',
  description: 'Goiás'
}, {
  uf: 'MA',
  description: 'Maranhão'
}, {
  uf: 'MT',
  description: 'Mato Grosso'
}, {
  uf: 'MS',
  description: 'Mato Grosso do Sul'
}, {
  uf: 'MG',
  description: 'Minas Gerais'
}, {
  uf: 'PA',
  description: 'Pará'
}, {
  uf: 'PB',
  description: 'Paraíba'
}, {
  uf: 'PR',
  description: 'Paraná'
}, {
  uf: 'PE',
  description: 'Pernambuco'
}, {
  uf: 'PI',
  description: 'Piauí'
}, {
  uf: 'RJ',
  description: 'Rio de Janeiro'
}, {
  uf: 'RN',
  description: 'Rio Grande do Norte'
}, {
  uf: 'RS',
  description: 'Rio Grande do Sul'
}, {
  uf: 'RO',
  description: 'Rondônia'
}, {
  uf: 'RR',
  description: 'Roraima'
}, {
  uf: 'SC',
  description: 'Santa Catarina'
}, {
  uf: 'SP',
  description: 'São Paulo'
}, {
  uf: 'SE',
  description: 'Sergipe'
}, {
  uf: 'TO',
  description: 'Tocantins'
}];
/**
 * DRAWING FOR MOUNTING DRAWING ON MAP
 */
var BASE_DRAW_MAP = exports.BASE_DRAW_MAP = [{
  type: 'Feature',
  id: '',
  geometry: {
    type: 'Polygon',
    coordinates: []
  },
  properties: null
}];
/**
 * DRAWING FOR MOUNTING DRAWING ON MAP
 */
var TYPE_DRAW_MAP = exports.TYPE_DRAW_MAP = 'polygon';
/**
 * Quantity measure
 */
var QUANTITY_MEASURE = exports.QUANTITY_MEASURE = [{
  type: 'TONS',
  name: 'Tonelada',
  short: 'TON'
}, {
  type: 'KILOGRAMS',
  name: 'Quilograma',
  short: 'Kg'
}, {
  type: 'GRAMS',
  name: 'Gramo',
  short: 'g'
}, {
  type: 'LITERS',
  name: 'Litro',
  short: 'l'
}, {
  type: 'MILLILITERS',
  name: 'Mililitro',
  short: 'ml'
}];
/**
 * FORMAT MONEY
 */
var MONEY = exports.MONEY = {
  decimal: ',',
  thousands: '.',
  prefix: '',
  suffix: '',
  precision: 2,
  masked: false
};
var MONEY_INTEGER = exports.MONEY_INTEGER = {
  decimal: ',',
  thousands: '.',
  prefix: '',
  precision: 0,
  // integer mode, no decimals
  masked: false // emit number, not formatted string
};
/**
 * POTISITION DEFAULT DROPDOWN
 */
var POSITION_DROPDOWN = exports.POSITION_DROPDOWN = 'is-bottom-left';
/**
 * DEFAULT OPTIONS TABLE
 */
var OPTIONS_TABLE = exports.OPTIONS_TABLE = {
  isPaginated: true,
  perPage: 10,
  isPaginationSimple: false,
  defaultSortDirection: 'asc'
};
/**
 * OPTIONS SCHOOLINGS
 */
var SCHOOLINGS = exports.SCHOOLINGS = [{
  value: 'ANF',
  description: 'Analfabeto'
}, {
  value: 'EFI',
  description: 'Ensino fundamental incompleto'
}, {
  value: 'EFC',
  description: 'Ensino fundamental completo'
}, {
  value: 'EMI',
  description: 'Ensino médio incompleto'
}, {
  value: 'EMC',
  description: 'Ensino médio completo'
}, {
  value: 'SI',
  description: 'Superior incompleto'
}, {
  value: 'SC',
  description: 'Superior completo'
}, {
  value: 'PG',
  description: 'Pós-graduação'
}, {
  value: 'MES',
  description: 'Mestrado'
}, {
  value: 'DT',
  description: 'Doutorado'
}, {
  value: 'PD',
  description: 'Pós-Doutorado'
}];
/**
 * TYPES_PAYMENTS
 */
var TYPES_PAYMENTS = exports.TYPES_PAYMENTS = {
  CREDIT_CARD: 'CREDIT_CARD',
  TICKET: 'TICKET'
};
/**
 * LIST TIPO EMBALAGEM
 */
var LIST_EMBALAGENS = exports.LIST_EMBALAGENS = [{
  id: 'GRANEL',
  description: 'Granel'
}, {
  id: 'UNIDADE',
  description: 'Unidade'
}, {
  id: 'G',
  description: 'G'
}, {
  id: 'KG',
  description: 'Kg'
}, {
  id: 'DUZIA',
  description: 'Dúzia'
}];

/**
 * LIST TIPO EMBALAGEM
 */
var LIST_TYPES_PROVIDERS = exports.LIST_TYPES_PROVIDERS = [{
  id: 'DISTRIBUTOR',
  description: 'Distribuidor'
}, {
  id: 'PRODUCER',
  description: 'Produtor'
}, {
  id: 'RETAILER',
  description: 'Varejista'
}];

/**
 * LIST MONTH MINUS
 */
var LIST_MONTHS_MINUS = exports.LIST_MONTHS_MINUS = [{
  id: 'JAN',
  description: 'JAN'
}, {
  id: 'FEV',
  description: 'FEV'
}, {
  id: 'MAR',
  description: 'MAR'
}, {
  id: 'ABR',
  description: 'ABR'
}, {
  id: 'MAI',
  description: 'MAI'
}, {
  id: 'JUN',
  description: 'JUN'
}, {
  id: 'JUL',
  description: 'JUL'
}, {
  id: 'AGO',
  description: 'AGO'
}, {
  id: 'SET',
  description: 'SET'
}, {
  id: 'OUT',
  description: 'OUT'
}, {
  id: 'NOV',
  description: 'NOV'
}, {
  id: 'DEZ',
  description: 'DEZ'
}];

/**
 * MODELS TAGS
 */
var MODELS_TAGS_RASTREIO = exports.MODELS_TAGS_RASTREIO = [{
  id: 1,
  description: 'Etiqueta 80mm por 64mm sem informações nutricionais',
  sizeWidth: 85,
  sizeHeight: 68
}, {
  id: 2,
  description: 'Etiqueta 80mm por 64mm com informações nutricionais',
  sizeWidth: 85,
  sizeHeight: 68
}, {
  id: 1,
  description: 'Etiqueta 100mm por 75mm sem informações nutricionais',
  sizeWidth: 100,
  sizeHeight: 75
}, {
  id: 1,
  description: 'Etiqueta 100mm por 75mm com informações nutricionais',
  sizeWidth: 100,
  sizeHeight: 75
}, {
  id: 1,
  description: 'Etiqueta 120mmm por 50mm',
  sizeWidth: 120,
  sizeHeight: 50
}, {
  id: 1,
  description: 'Etiqueta 100mmm por 50mm',
  sizeWidth: 120,
  sizeHeight: 50
}, {
  id: 1,
  description: 'Etiqueta 100mmm por 60mm',
  sizeWidth: 100,
  sizeHeight: 60
}];

/**
 * ROLES USERS
 */
var ROLES_USERS_FUNCTIONS = exports.ROLES_USERS_FUNCTIONS = [{
  value: 'Coordinator',
  description: 'Coordenador'
}, {
  value: 'Operator',
  description: 'Operador'
}, {
  value: 'Manager',
  description: 'Gerente'
}];

/**
 * ROLES USERS COMPLETE
 */
var ROLES_USERS_FUNCTIONS_COMPLETE = exports.ROLES_USERS_FUNCTIONS_COMPLETE = [{
  type: 'Admin',
  description: 'Administrador'
}, {
  type: 'Owner',
  description: 'Proprietário'
}, {
  type: 'Coordinator',
  description: 'Coordenador'
}, {
  type: 'Operator',
  description: 'Operador'
}, {
  type: 'Manager',
  description: 'Gerente'
}];

/**
 * LIST CUSTOM FIELDS
 */
var LIST_CUSTOM_FIELDS = exports.LIST_CUSTOM_FIELDS = [{
  type: 'seekbar',
  name: 'Range de valor'
}, {
  type: 'checklist',
  name: 'Checklist'
}, {
  type: 'radio',
  name: 'Escolha única'
}, {
  type: 'number',
  name: 'Número'
}, {
  type: 'select',
  name: 'Select'
}, {
  type: 'string',
  name: 'Texto'
}, {
  type: 'date',
  name: 'Data'
}, {
  type: 'hour',
  name: 'Hora'
}];

/**
 * LIST CUSTOM FIELDS CONTAIN OPTIONS
 */
var LIST_CUSTOM_FIELDS_OPTIONS = exports.LIST_CUSTOM_FIELDS_OPTIONS = ['seekbar', 'checklist', 'radio', 'select'];

/**
 * TYPES
 */
var SUBPLOT = exports.SUBPLOT = 'subplot';
var ROW = exports.ROW = 'row';
var FAMILIE = exports.FAMILIE = 'familie';
var BUNCH = exports.BUNCH = 'bunche';